export default {
  adminState: state => state.adminInfo,
  activePage: state => state.activePage,
}
